module.exports = __webpack_public_path__ + "static/img/testimony (40).991b3dad.jpg";